import { localCache } from "@overrides/utilities";
import { type CacheKey, cacheKey } from "./cache-key";

/**
 * The lodging funnel a hotel was opened under, keyed by the hotel and its stay
 * search. Written by the hotel list when a card is about to be opened, read by
 * the shop page so a shop opened in a new tab (empty sessionStorage) inherits
 * the funnel of the search it came from instead of minting its own. Same
 * hand-off as `availabilityTokenCache` uses for the shop token.
 */
export const funnelIdCache = localCache<CacheKey>({
  prefix: "lodging-funnel-id-cache",
  cacheKey,
  maxItems: 40,
});
